import { render, staticRenderFns } from "./StudyHistory.vue?vue&type=template&id=4d0d0bc9&scoped=true&"
import script from "./StudyHistory.vue?vue&type=script&lang=js&"
export * from "./StudyHistory.vue?vue&type=script&lang=js&"
import style0 from "./StudyHistory.vue?vue&type=style&index=0&id=4d0d0bc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0d0bc9",
  null
  
)

export default component.exports